import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  setLogueado(valor: boolean): void {
    sessionStorage.setItem('logueado', JSON.stringify(valor));
  }

  isLogueado(): boolean {
    return JSON.parse(sessionStorage.getItem('logueado') || 'false');
  }

  logout(): void {
    sessionStorage.removeItem('logueado');
  }
}
